// Copyright 2025, University of Maryland, All Rights Reserved
import { memo } from 'react'
import { RefreshCw } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'

export const FederalConnectorSyncWorkflowNode = memo(() => (
  <BaseNode
    icon={<RefreshCw />}
    label="Federal Connector Sync"
    hasInput
  />
))

FederalConnectorSyncWorkflowNode.displayName = 'FederalConnectorSyncWorkflowNode'
